import { Link } from 'react-router-dom';
import { useEffect, useState } from 'react';
import MobileMenu from './MobileMenu';

export default function CaseStudyPageNav() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <>
      <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${scrolled ? 'bg-white shadow-sm' : 'bg-white shadow-sm'}`}>
        <div className="max-w-7xl mx-auto px-6 lg:px-12">
          <div className="flex items-center justify-between h-24">
            <Link to="/" className="flex items-center">
              <img
                src="https://static.readdy.ai/image/7afcb539829d8ddcd28f62262d25b133/511aeba7affe24966a38635cdd087c13.png"
                alt="Design For"
                className="h-16"
              />
            </Link>
            <div className="hidden md:flex items-center space-x-10">
              <Link to="/" className="text-black hover:text-primary transition-colors duration-200 text-sm font-medium uppercase tracking-wider">Home</Link>
              <Link to="/about" className="text-black hover:text-primary transition-colors duration-200 text-sm font-medium uppercase tracking-wider">About</Link>
              <Link to="/services" className="text-black hover:text-primary transition-colors duration-200 text-sm font-medium uppercase tracking-wider">Services</Link>
              <Link to="/work" className="text-primary transition-colors duration-200 text-sm font-medium uppercase tracking-wider">Work</Link>
              <Link to="/resources" className="text-black hover:text-[#ff4858] transition-colors duration-200 text-sm font-medium uppercase tracking-wider">Insights</Link>
              <Link to="/contact" className="bg-primary text-white px-6 py-3 rounded-full hover:bg-primary/90 transition-all duration-200 text-sm font-bold uppercase tracking-wider whitespace-nowrap">
                Contact
              </Link>
            </div>
            <button onClick={() => setMobileMenuOpen(true)} className="md:hidden text-black">
              <i className="ri-menu-line text-3xl"></i>
            </button>
          </div>
        </div>
      </nav>
      <MobileMenu isOpen={mobileMenuOpen} onClose={() => setMobileMenuOpen(false)} />
    </>
  );
}
